import { render, staticRenderFns } from "./RatingEndorsements.vue?vue&type=template&id=26e37fe3"
import script from "./RatingEndorsements.vue?vue&type=script&lang=ts"
export * from "./RatingEndorsements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports